import React from 'react'
import withView from '../../cmn/docAutomation/withView';
import FormTitle from '../../../library/form/components/FormTitle';
import FormROValue from '../../../library/form/components/FormROValue1';
import FormInput from '../../../library/form/components/FormInput';
import FormCheckbox from '../../../library/form/components/FormCheckbox';
import FormLabel from '../../../library/form/components/FormLabel'
import FormRichText from '../../../library/form/components/FormRichText'
import FormDialog from '../../../library/form/components/FormDialog';
import FormWrapper from '../../../library/form/components/FormWrapper';
import FormHHMMInput from '../../../library/form/components/FormHHMMInput';

const ProjectHoldResumeEditor = (props) => {
    const { formObject, viewData, ...restProps } = props;

    if (!viewData)
        return null

    return (
        <FormDialog onDynamicViewClose={restProps.onDynamicViewClose} enablePopup={true} formObject={formObject}
            action={{ formActions: { forAction: "Confirm", forCancel: "Cancel" } }} contentStyle={{height:"400px"}}
            formStyle={{ width: '600px', height: '500px' }} formTitle={<FormTitle formObject={formObject} value="Hold Resume Job" />}
        >
            <div>
                <div>
                    <span className="uiLbl">
                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "taskName" }} value="Process" />
                    </span>
                    <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "taskName" }} className='uiLbl uiDisplayInline' />
                </div>
                <div>
                    <span className="uiLbl">
                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "reason" }} value="Reason for Hold" />
                    </span>
                    <FormInput formObject={formObject} rowKey="" className="uiInput" action={{
                        InputType: "ac",
                        paramName: "reason", acMethod: "CategoryDetail", acDepCtrl: { 'dparam': "%dataList.valLCat" }
                    }} />
                    <span className="uiLblInLine">
                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "holdOn" }} value="Hold On" />
                    </span>
                    <FormInput formObject={formObject} rowKey="" className="uiVal mousetrap"
                        action={{ InputType: "dp", paramName: "holdOn", actionParam: {} }} />
                    <FormHHMMInput formObject={formObject} rowKey="" className="uiTimeInput" 
                        action={{ InputType: "input", paramName: "holdOnTime", actionParam: {} }} />
                </div>
                <div>
                    <span className="uiLbl">
                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "holdComment" }} value="Comment" />
                    </span>
                    <FormRichText formObject={formObject} rowKey="" rows="5" cols="82" className=""
                        action={{ paramName: "holdComment" }} />
                </div>

                <FormWrapper customWrapper="div" formObject={formObject} rowKey="" action={{ paramName: "resumeEditor" }} >
                    <div>
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "isResumed" }} value="Is Resumed" />
                        </span>
                        <FormCheckbox formObject={formObject} rowKey='' action={{ InputType: "onOff", paramName: "isResumed" }} />
                        <span className="uiLblInLine">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "resumeOn" }} value="Resume On" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" className="uiVal mousetrap"
                            action={{ InputType: "dp", paramName: "resumeOn", actionParam: {} }} />
                        <FormHHMMInput formObject={formObject} rowKey="" className="uiTimeInput" 
                            action={{ InputType: "input", paramName: "resumeOnTime", actionParam: {} }} />
                    </div>
                    <div>
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "resumeComment" }} value="Comment" />
                        </span>

                        <FormRichText formObject={formObject} rowKey="" rows="5" cols="82" className=""
                            action={{ paramName: "resumeComment" }} />
                    </div>
                </FormWrapper>
            </div>
        </FormDialog>
    )
}

export default withView(ProjectHoldResumeEditor, "projectHold", "projectHold,prodTask,prodHeader")